var t = require('js/lib/translate').t;

usersCtrl.$inject = ['$scope', '$rootScope', '$controller', '$routeParams', '$filter'];

function usersCtrl($scope, $rootScope, $controller, $routeParams, $filter) {

  $controller('planCtrl', { $scope: $scope });

  $scope.search = {
    text: undefined
  };

  $scope.formatPhone = require('js/lib/util').formatPhone;

  $scope.filter = {
    active: true
  };

  $scope.languages = [
    { id: 'no', name: 'Norsk' },
    { id: 'sv', name: 'Svenska' },
    { id: 'fi', name: 'Suomalainen' },
    { id: 'en', name: 'English' },
    { id: 'fr', name: 'Français' }
  ];

  $scope.setStatus = function($event, active) {
    $scope.filter.active = active;
    $event.preventDefault();
  };

  $scope.countStatus = function(active) {
    var users = $rootScope.users;

    return $filter('filter')(users, {
      active: active
    }).length;
  };

}

module.exports = usersCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controllers/usersCtrl.js
 ** module id = 134
 ** module chunks = 1
 **/